/**
 * Set raycast target as a child independnent from entity.
 * Useful for padding the raycast target of a mesh without changing the mesh.
 */
AFRAME.registerComponent('raycaster-target', {
  schema: {
    bindToggle: {default: ''},
    depth: {type: 'number'},
    height: {type: 'number'},
    position: {type: 'vec3', default: {x: 0, y: 0, z: 0}},
    rotation: {type: 'vec3', default: {x: 0, y: 0, z: 0}},
    useBoxTarget: {default: false},
    width: {type: 'number'}
  },

  init: (function () {
    var boxGeometry = {primitive: 'box'};
    var planeGeometry = {primitive: 'plane'};

    return function () {
      var data = this.data;
      var el = this.el;
      var geometry;
      var raycastTarget;

      raycastTarget = document.createElement('a-entity');
      raycastTarget.classList.add('raycasterTarget');

      if (data.bindToggle) {
        raycastTarget.setAttribute('bind-toggle__raycastable', data.bindToggle);
      } else {
        raycastTarget.setAttribute('data-raycastable', '');
      }

      if (data.useBoxTarget) {
        // 3D target.
        geometry = boxGeometry;
        geometry.depth = data.depth;
        geometry.height = data.height;
        geometry.width = data.width;
      } else {
        // 2D target.
        geometry = planeGeometry;
        geometry.height = data.height;
        geometry.width = data.width;
      }
      raycastTarget.setAttribute('geometry', geometry);

      raycastTarget.object3D.visible = false;
      raycastTarget.object3D.position.copy(data.position);
      raycastTarget.object3D.rotation.x = THREE.Math.degToRad(data.rotation.x);
      raycastTarget.object3D.rotation.y = THREE.Math.degToRad(data.rotation.y);
      raycastTarget.object3D.rotation.z = THREE.Math.degToRad(data.rotation.z);

      el.appendChild(raycastTarget);
    };
  })()
});
if (module.hot && window.AFRAME) {
  const componentNames = ['raycaster-target',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
